export const actions = {
  BIBPLANTILLA_FILTERED_LOAD_REQUESTED: 'BIBPLANTILLA_FILTERED_LOAD_REQUESTED',
  BIBPLANTILLA_FILTERED_LOAD_SUCCEEDED: 'BIBPLANTILLA_FILTERED_LOAD_SUCCEEDED',
  BIBPLANTILLA_FILTERED_LOAD_FAILED: 'BIBPLANTILLA_FILTERED_LOAD_FAILED',

  BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_REQUESTED:
    'BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_REQUESTED',
  BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_SUCCEEDED:
    'BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_SUCCEEDED',
  BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_FAILED: 'BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_FAILED',

  DELETE_BIBPLANTILLA_REQUESTED: 'DELETE_BIBPLANTILLA_REQUESTED',
  DELETE_BIBPLANTILLA_SUCCEEDED: 'DELETE_BIBPLANTILLA_SUCCEEDED',
  DELETE_BIBPLANTILLA_FAILED: 'DELETE_BIBPLANTILLA_FAILED',

  BIBPLANTILLA_INSERT_REQUESTED: 'BIBPLANTILLA_INSERT_REQUESTED',
  BIBPLANTILLA_INSERT_SUCCEEDED: 'BIBPLANTILLA_INSERT_SUCCEEDED',
  BIBPLANTILLA_INSERT_FAILED: 'BIBPLANTILLA_INSERT_FAILED',

  BIBPLANTILLA_UPDATE_REQUESTED: 'BIBPLANTILLA_UPDATE_REQUESTED',
  BIBPLANTILLA_UPDATE_SUCCEEDED: 'BIBPLANTILLA_UPDATE_SUCCEEDED',
  BIBPLANTILLA_UPDATE_FAILED: 'BIBPLANTILLA_UPDATE_FAILED',

  BIBPLANTILLA_BYID_LOAD_REQUESTED: 'BIBPLANTILLA_BYID_LOAD_REQUESTED',
  BIBPLANTILLA_BYID_LOAD_SUCCEEDED: 'BIBPLANTILLA_BYID_LOAD_SUCCEEDED',
  BIBPLANTILLA_BYID_LOAD_FAILED: 'BIBPLANTILLA_BYID_LOAD_FAILED',

  BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_REQUESTED: 'BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_REQUESTED',
  BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_SUCCEEDED: 'BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_SUCCEEDED',
  BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_FILED: 'BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_FILED',

  BIBSPLANTILLA_PRODUCTO_UPDATE_REQUESTED: 'BIBSPLANTILLA_PRODUCTO_UPDATE_REQUESTED',
  BIBSPLANTILLA_PRODUCTO_UPDATE_SUCCEEDED: 'BIBSPLANTILLA_PRODUCTO_UPDATE_SUCCEEDED',
  BIBSPLANTILLA_PRODUCTO_UPDATE_FAILED: 'BIBSPLANTILLA_PRODUCTO_UPDATE_FAILED',
}

export const getBibPlantillaFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBPLANTILLA_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const getBibPlantillaFilteredWithFilesAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBPLANTILLA_FILTERED_WITH_FILES_LOAD_REQUESTED,
    payload: filter,
  })
}

export const deleteBibPlantillaAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_BIBPLANTILLA_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertBibPlantillaFormAction = (dispatch, formBibPlantilla) => {
  dispatch({
    type: actions.BIBPLANTILLA_INSERT_REQUESTED,
    payload: formBibPlantilla,
  })
}

export const onSubmitUpdateBibPlantillaFormAction = (dispatch, formBibPlantilla) => {
  dispatch({
    type: actions.BIBPLANTILLA_UPDATE_REQUESTED,
    payload: formBibPlantilla,
  })
}

export const getBibPlantillaByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BIBPLANTILLA_BYID_LOAD_REQUESTED,
      payload: id,
    })
  }
}

export const getBibPlantillaByProductoIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBPLANTILLA_BY_PRODUCTO_ID_LOAD_REQUESTED,
    payload: id,
  })
}

export const updateBibsPlantillaProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBSPLANTILLA_PRODUCTO_UPDATE_REQUESTED,
    payload,
  })
}
